import { EnrichedWarehouse, useWarehouseContext } from '../context/WarehouseContext';

/**
 * Convenience hook around useWarehouseContext, will never return undefined (it will throw if no warehouse is selected).
 *
 * **Note:** ONLY USE THIS HOOK INSIDE `UrlWarehouseProvider` if you know what's good for you.
 * @returns The current warehouse.
 * @throws If the WarehouseContext is not available, or if a warehouse is not selected.
 */
export const useSelectedWarehouse = (): EnrichedWarehouse => {
  const ctx = useWarehouseContext();

  if (!ctx.warehouse) {
    throw new Error('Expected a warehouse to be selected, but none was found');
  }

  return ctx.warehouse;
};
